export const CMS_LANGUAGES = [
  { value: '1', label: 'Deutsch (DE)' },
  { value: '2', label: 'Englisch (EN)' },
  { value: '3', label: 'Französisch (FR)' },
  { value: '4', label: 'Spanisch (ES)' },
  { value: '5', label: 'Italienisch (IT)' },
  { value: '6', label: 'Finnisch (FI)' },
  { value: '7', label: 'Niederländisch (NL)' },
  { value: '8', label: 'Norwegisch (NO)' },
  { value: '9', label: 'Portugiesisch (PT)' },
  { value: '10', label: 'Serbisch (SR)' },
  { value: '11', label: 'Schwedisch (SV)' },
  { value: '12', label: 'Koreanisch (KO)' },
  { value: '13', label: 'Japanisch (JA)' },
  { value: '14', label: 'Chinesisch (ZH)' },
  { value: '18', label: 'Polnisch (PL)' },
  { value: '19', label: 'Dänisch (DA)' },
  { value: '21', label: 'Rumänisch (RO)' },
  { value: '22', label: 'Tschechisch (CS)' },
  { value: '23', label: 'Ungarisch (HU)' },
];

export const CMS_LANGUAGE_IDS = CMS_LANGUAGES.map(({ value }) => value);
